import { render } from "./BaseCard.vue?vue&type=template&id=0bfb178b&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=0bfb178b&scoped=true&lang=css"

import exportComponent from "/builds/coditas-projects/dialog360-whatsapp/frontend/whatsapp-exotel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bfb178b"]])

export default __exports__